import { render, staticRenderFns } from "./LopdText.vue?vue&type=template&id=729f13eb&"
import script from "./LopdText.vue?vue&type=script&lang=js&"
export * from "./LopdText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports